export default __webpack_public_path__ + "static/RootSans-6Italic-29aca17da1f675a94bc7db50e5341acb.woff";